import { render, staticRenderFns } from "./TransactionTypesTable.vue?vue&type=template&id=c55195ac"
import script from "./TransactionTypesTable.vue?vue&type=script&lang=js"
export * from "./TransactionTypesTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTypesTable.vue?vue&type=style&index=0&id=c55195ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports